import React from "react";
import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";

export default createSvgIcon(
  <React.Fragment>
    <path
      fillRule="evenodd"
      d="M22 6H7L6 2H2v1.6h2.5L6 9.5c0 6.528 3.002 6.5 4 6.5h9.503v-1.6H10c-1.5 0-1.347-.882-1.347-1.23 0-.231.117-.484.66-.605L21 11.167 22 6zm-5 12c-1.125 0-2 .875-2 2s.875 2 2 2 2-.875 2-2-.875-2-2-2zm-7 0c-1.125 0-2 .875-2 2s.875 2 2 2 2-.875 2-2-.875-2-2-2z"
    />
  </React.Fragment>,
  `BasketIcon`
);
